import { atom } from "jotai";
import { uuid } from "../utils";
import { Notification, NotificationOptions } from "../types";

// Atom to hold the list of notifications
export const notificationsAtom = atom<Notification[]>([]);
notificationsAtom.debugLabel = "notificationsAtom";

export const createNotificationSetter = atom(
  null,
  (_, set, options: NotificationOptions) => {
    const newNotification: Notification = {
      ...options,
      id: `notification-${uuid()}`,
    };

    set(notificationsAtom, (prev) => [...prev, newNotification]);
  },
);

createNotificationSetter.debugLabel = "createNotificationSetter";
